export default function(fields, oldQuestions) {
  let profileQuestionOptions = []

  if (fields.questionOptions) {
    profileQuestionOptions = fields.questionOptions.map(item => ({
      translatedText: item.value
    }))
  }

  return {
    profileQuestions: oldQuestions.concat({
      translatedText: fields.questionText,
      questionType: fields.questionType,
      isOptional: fields.isOptional,
      parentalConsentHide: fields.parentalConsentHide,
      parentalConsentOnly: fields.parentalConsentOnly,
      profileQuestionOptions
    })
  }
}
